<div class="accept-clauses-container" fxLayout="row" fxLayoutAlign="center">
    <div fxFlex="40" fxFlex.lt-md="100">
        <div class="accept-clauses-content" fxLayout="column">
            <mat-card class="accept-clauses-card mat-elevation-z0">
                <form [formGroup]="form">
                    <mat-card-title fxLayoutAlign="center">
                        <span class="text-accent">{{ 'Accept clauses'|i18n }}</span>
                    </mat-card-title>
                    <mat-card-content class="mt-20" fxLayout="column" fxLayoutAlign="space-around center">
                        <section class="terms-section" fxLayout="column" fxLayoutGap="10px">
                            <mat-checkbox app-checkbox *ngIf="termsAndConditions" formControlName="termsAccepted">
                                {{ 'read-and-acceptance-terms'|i18n }}
                                <a href="javascript:void(0);" rel="noopener noreferrer"
                                   (click)="openECDocLink(termsAndConditionsLink)">
                                    {{ 'Terms and Conditions'|i18n }}
                                </a>
                            </mat-checkbox>
                            <mat-checkbox app-checkbox *ngIf="unfairClauses" formControlName="unfairAccepted">
                                {{ 'read-and-acceptance-clauses'|i18n }}
                                <a href="javascript:void(0);" rel="noopener noreferrer"
                                   (click)="openECDocLink(specificClausesLink)">
                                    {{ 'Clauses__{profile}'|i18n }}
                                </a>
                            </mat-checkbox>
                            <mat-checkbox app-checkbox *ngIf="privacy" formControlName="privacyAccepted">
                                {{ 'read-and-acceptance-privacy'|i18n }}
                                <a href="javascript:void(0);" rel="noopener noreferrer"
                                   (click)="privacyPolicyDocumentId ?
                                   openECDocId(privacyPolicyDocumentId) :
                                   openECDocLink(privacyPolicyLink)">
                                    {{ 'Privacy Policy__{profile}'|i18n }}
                                </a>
                            </mat-checkbox>
                        </section>
                        <mat-card-actions fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-around center"
                                          class="mt-12">
                            <button mat-flat-button class="accept-clauses-button" color="primary" type="submit"
                                    [disabled]="busy || form.invalid" (click)="acceptClauses()">
                                {{ 'Confirm'|i18n }}
                            </button>
                            <div fxLayout="row" fxLayoutAlign="start center" *ngIf="busy">
                                <mat-spinner class="ml-8" diameter="30"></mat-spinner>
                                <div class="ml-8">{{ 'Redirecting...'|i18n }}</div>
                            </div>
                        </mat-card-actions>
                    </mat-card-content>
                </form>
            </mat-card>
        </div>
    </div>
</div>
